import clsx from 'clsx';

type Variant = 'success' | 'failure' | 'info' | 'warning';

type AlertProps = {
  variant?: Variant;
  icon?: React.ReactNode;
  children: React.ReactNode;
  className?: string;
};

export default function Alert({
  variant = 'info',
  icon,
  children,
  className,
  ...rest
}: AlertProps) {
  const classNames: Record<Variant, string> = {
    info: 'text-[#0369A1] bg-[#E0F2FE] text-sm font-medium leading-5 tracking-[0.21px]',
    failure: '',
    warning: '',
    success: 'bg-[#D1FAE5] text-[#047857] text-base leading-normal',
  };

  const iconClasses: Record<Variant, string> = {
    info: '[&_svg]:size-5',
    failure: '',
    warning: '',
    success: '[&_svg]:size-6',
  };

  return (
    <div
      className={clsx(
        'flex items-start gap-2 w-full p-2 rounded-lg',
        classNames[variant],
        className
      )}
      {...rest}
    >
      <div className={clsx('flex items-center justify-center', iconClasses[variant])}>{icon}</div>
      <div className="flex flex-col gap-2">{children}</div>
    </div>
  );
}
